import { collectUniqueScalarValues } from '../../../components/shared/GridColumnFilterPanel';
import type { Company, CompanyColumnFilterKey } from '../models/types';
import { COMPANY_COLUMN_FILTER_LABELS } from '../constants/constants';

type CompanyFilterColumnConfig = {
  key: CompanyColumnFilterKey;
  label: string;
  getOptions: (rows: Company[]) => string[];
};

export const COMPANY_FILTER_COLUMNS: CompanyFilterColumnConfig[] = [
  {
    key: 'country',
    label: COMPANY_COLUMN_FILTER_LABELS.country,
    getOptions: (rows) =>
      collectUniqueScalarValues(rows, (row) => String(row.country || '—')),
  },
  {
    key: 'industry',
    label: COMPANY_COLUMN_FILTER_LABELS.industry,
    getOptions: (rows) =>
      collectUniqueScalarValues(rows, (row) => String(row.industry || '—')),
  },
  {
    key: 'status',
    label: COMPANY_COLUMN_FILTER_LABELS.status,
    getOptions: (rows) =>
      collectUniqueScalarValues(rows, (row) => String(row.status || 'Inactive')),
  },
];

export function buildCompanyColumnFilterFields(companies: Company[]) {
  return COMPANY_FILTER_COLUMNS.map(({ key, label, getOptions }) => ({
    key,
    label,
    options: getOptions(companies),
  }));
}
